exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\r\n * Application global variables.\r\n */\n.center {\n  margin: auto;\n  margin-top: 20px; }\n.content-nf {\n  min-height: 200px; }\n.rounded-btn-nf {\n  border-radius: 0.99rem !important;\n  width: 200px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// d:/workspace/wynk_web_shoppings_3_prod/src/app/shopping-promotion-nf-form/shopping-promotion-nf-form.component.scss
// module id = ../../../../../src/app/shopping-promotion-nf-form/shopping-promotion-nf-form.component.scss
// module chunks = main